/* tslint:disable */
/* eslint-disable */
/**
 * EMLINX API specification
 * This is API specification for EMLINX project.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { ErrorResponse } from '../models';
// @ts-ignore
import { ListPoliciesResponse } from '../models';
/**
 * ListpoliciesApi - axios parameter creator
 * @export
 */
export const ListpoliciesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List Policies
         * @summary GET Policies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPolicies: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/policies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ListpoliciesApi - functional programming interface
 * @export
 */
export const ListpoliciesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ListpoliciesApiAxiosParamCreator(configuration)
    return {
        /**
         * List Policies
         * @summary GET Policies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPolicies(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPoliciesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPolicies(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ListpoliciesApi.listPolicies']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * ListpoliciesApi - factory interface
 * @export
 */
export const ListpoliciesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ListpoliciesApiFp(configuration)
    return {
        /**
         * List Policies
         * @summary GET Policies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPolicies(options?: any): AxiosPromise<ListPoliciesResponse> {
            return localVarFp.listPolicies(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ListpoliciesApi - object-oriented interface
 * @export
 * @class ListpoliciesApi
 * @extends {BaseAPI}
 */
export class ListpoliciesApi extends BaseAPI {
    /**
     * List Policies
     * @summary GET Policies
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListpoliciesApi
     */
    public listPolicies(options?: RawAxiosRequestConfig) {
        return ListpoliciesApiFp(this.configuration).listPolicies(options).then((request) => request(this.axios, this.basePath));
    }
}

